// extracted by mini-css-extract-plugin
export default {"Container":"ManufacturerTicketDetails_Container__5FJ+E","HeaderRight":"ManufacturerTicketDetails_HeaderRight__38ESq","Avatar":"ManufacturerTicketDetails_Avatar__sDKKh"};